import React from "react";
import Dictionary from "./Dictionary";
import logo from "./logo.png";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="AppHeader mt-5">
          <img src={logo} alt="heading" />
        </div>
        <main>
          <Dictionary />
        </main>
        <footer className="Footer mt-3 mb-3">
          This App was built by
          <a
            href="https://incandescent-tapioca-00054a.netlify.app/"
            rel="noreferrer"
            target="_blank"
          >
            {" "}
            Melissa Nzekele,
          </a>{" "}
          open-sourced on{" "}
          <a
            href="https://github.com/Meli-Nzekele/dictionary-react-app"
            rel="noreferrer"
            target="_blank"
          >
            GitHub
          </a>{" "}
          / Hosted on{" "}
          <a
            href="https://cheerful-tarsier-e979c2.netlify.app/"
            rel="noreferrer"
            target="_blank"
          >
            Netlify
          </a>
          <br />
          heading generated by{" "}
          <a
            href="https://www.font-generator.com/fonts/Action-Jackson/?size=70&color=c34e53&bg=ffffff"
            rel="noreferrer"
            target="_blank"
          >
            Font-Generated.com
          </a>
        </footer>
      </div>
    </div>
  );
}
